import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { JsonObjectFactoryService } from '../../../shared/_services/json-object-factory.service';

@Injectable({
  providedIn: 'root'
})
export class JobDisplayService {
  constructor(private jsonObjectFactoryService: JsonObjectFactoryService) {}

  saveJobDisplay(
    baseUrl: string,
    data: any,
    globalService: any = {},
    filterParams: any = {}
  ): Observable<any> {
    if (!data?.rowData || data.rowData[data.col_id] === data?.oldRowData?.[data.col_id]) {
      return of({ callSuccess: '1', skipped: true });
    }
    const clobData = [data.rowData];
    const clobSetting = {
      tax_year: data.rowData.TAX_YEAR,
      scenario: data.rowData.SCENARIO
    };
    const params: any = {
      clob_data: JSON.stringify(clobData),
      clob_setting: JSON.stringify(clobSetting)
    };
    return this.jsonObjectFactoryService.saveJSON6(
      `${baseUrl}/saveJsonObject?action_code=0pnshs`,
      params,
      globalService,
      filterParams
    );
  }
}
